import React from "react";
import AgraserPage from "../components/Projects/AgraserPage";
import ProjectsAnimation from "../components/Projects/ProjectsAnimation";

const Agraser = () => {
  return (
    <div className="z-30 relative">
      <ProjectsAnimation />
      <AgraserPage />
    </div>
  );
};

export default Agraser;
